import i18next from 'i18next'

import en from './data/en.json'

export const ORGANISATION_PROFILE_NAMESPACE = 'organisationProfile'
export const DEFAULT_LOCALE = 'en-US'

type KeyPaths<T> = {
  [K in keyof T & string]: T[K] extends Record<string, unknown>
    ? `${K}.${KeyPaths<T[K]>}`
    : K
}[keyof T & string]

type PluralSuffix = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other'
type WithoutPluralSuffix<K> = K extends `${infer Base}_${PluralSuffix}`
  ? Base
  : K

export type TranslationKey = WithoutPluralSuffix<KeyPaths<typeof en>>

// Own instance, so host apps' i18next config (e.g. CP's `{x}` interpolation) never leaks in.
export const organisationProfileI18n = i18next.createInstance()

organisationProfileI18n.init({
  resources: {
    [DEFAULT_LOCALE]: { [ORGANISATION_PROFILE_NAMESPACE]: en },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  ns: [ORGANISATION_PROFILE_NAMESPACE],
  defaultNS: ORGANISATION_PROFILE_NAMESPACE,
  initImmediate: false,
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
})
